import { ReactNode } from "react";
import standardSlugify from "standard-slugify";

type MarkdownChildren = ReactNode | ReactNode[];

/**
 * Безопасно превращает children в строку,
 * предотвращая появление [object Object]
 */
function normalizeChildren(children: MarkdownChildren): string {
  if (typeof children === "string") return children;
  if (Array.isArray(children)) {
    return children
      .map((c) => (typeof c === "string" ? c : ""))
      .join(" ")
      .trim();
  }
  return "";
}

/**
 * Возвращает безопасный slug.
 * Если переданы некорректные данные — вернёт undefined.
 */
export function safeSlug(children: MarkdownChildren): string | undefined {
  const text = normalizeChildren(children);
  return text ? standardSlugify(text) : undefined;
}

/**
 * Проверяет, является ли ссылка внешней.
 */
export function isExternalLink(href: string): boolean {
  return (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("//")
  );
}
